module.exports = __webpack_public_path__ + "img/banner8.b750310a.png";